document.addEventListener("DOMContentLoaded", function() {
    //Configuración de los textos por idiomas.
    const traducciones = {
        "es": "Esencial para {num} licolovers",
        "pt": "Essencial para {num} licolovers",
        "default": "Esencial para {num} licolovers"
    };

    //Cambiar texto
    function actualizarCopyStamped() {
        const badges = document.querySelectorAll('.stamped-badge-caption:not(.custom-updated)');

        badges.forEach(badge => {
            const numeroResenas = badge.getAttribute('data-reviews');

            // A partir de 15 reseñas
            if (!isNaN(numeroResenas) && numeroResenas >= 15) {
                const lang = document.documentElement.lang.split('-')[0];

                let plantillaTexto = traducciones[lang] || traducciones['default'];

                badge.textContent = plantillaTexto.replace('{num}', numeroResenas);
                badge.style.display = 'inline-block';
            }

            badge.classList.add('custom-updated');
        });
    }

    const observer = new MutationObserver((mutations) => {
        actualizarCopyStamped();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});